import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(process.env.REACT_APP_EMAILJS_SERVICE_ID, process.env.REACT_APP_EMAILJS_TEMPLATE_ID, form.current, {
        publicKey: process.env.REACT_APP_EMAILJS_PUBLICKEY,
      })
      .then(
        () => {
          console.log('SUCCESS!');
          toast("Message sent");
        },
        (error) => {
          console.log('FAILED...', error.text);
          toast("Message failed");
        },
      );
    form.current.reset();
  };


  return (
    <>
      <form ref={form} onSubmit={sendEmail}>
        <div class="w-11/12 mx-auto px-4 pb-12 border-b-2 border-black">
          {/* <label>Name</label>
          <input type="text" name="user_name" /> */}
          {/* <label>Email</label>
          <input type="email" name="user_email" /> */}
          {/* <label>Message</label> */}
          {/* <textarea name="message" /> */}
          {/* <input type="submit" value="Send" /> */}

          <div class="mt-10 flex flex-col">
            <div class="col-span-2">
              <label class="block text-sm font-medium leading-6 text-gray-900">Name</label>
              <div class="mt-2">
                <input type="text" name="user_name" autocomplete="off" class="w-1/3 block rounded-md border-0 py-1.5 px-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
              </div>
            </div>

            <div class="sm:col-span-3">
              <label class="block text-sm font-medium leading-6 text-gray-900">Email</label>
              <div class="mt-2">
                <input name="user_email" type="email" autocomplete="off" class="w-1/3 block rounded-md border-0 py-1.5 px-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
              </div>
            </div>

            <div class="col-span-full">
              <label class="block text-sm font-medium leading-6 text-gray-900">Message</label>
              <div class="mt-2">
                <textarea name="message" rows="5" class="w-1/2 block rounded-md border-0 py-1.5 px-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
              </div>
              <div class="py-2">
                <button type="submit" class="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Send</button>
              </div>
            </div>

          </div>
        </div>
      </form>
      <ToastContainer />
    </>
  )
}